

export const ModuleNodeButton  = ({
	type,
	price,
	onClick,
	isShown
}: {
	type: 'RESEARCH' | 'BUY' | 'DONATE',
	price: number,
	onClick: () => void,
	isShown: boolean
}) => {
	const getIcon = () => {
		switch (type) {
			case 'RESEARCH':
				return '/icons/32px/xp.png'
			case 'BUY':
				return '/icons/32px/money.png'
			case 'DONATE':
				return '/icons/32px/dp.png'
		}
	}

	const getClassNameByType = () => {
		switch (type) {
			case 'RESEARCH':
				return 'research'
			case 'BUY':
				return 'buy'
			case 'DONATE':
				return 'donate'
		}
	}

	return (
		<div className={`module-node-button ${getClassNameByType()}`} onClick={onClick} style={{ display: isShown ? 'flex' : 'none' }}> 
			<img className='module-node-button-icon' src={getIcon()} alt={type} />
			<p>{price}</p>
		</div>
	)
}